window.CWCollectionATCBridgeV4 = true;

if (window.CWMetafieldGiftATCInitialized) {
  console.warn('[MetafieldGiftATC] Already initialized.');
} else {
  window.CWMetafieldGiftATCInitialized = true;

  (function () {
    'use strict';

    var GIFT_MAX_QTY = 2;

    function parseJson(value) {
      if (!value) return null;

      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    }

    function getPDPConfig() {
      var configEl = document.getElementById('pf-config');
      return parseJson(configEl ? configEl.textContent : '{}') || {};
    }

    function getCartConfig() {
      var configEl = document.getElementById('cd-config');
      return parseJson(configEl ? configEl.textContent : '{}') || {};
    }

    function setCartConfig(config) {
      var configEl = document.getElementById('cd-config');
      if (!configEl || !config) return;

      configEl.textContent = JSON.stringify(config);
    }

    function normalizeIds(ids) {
      return (ids || [])
        .map(function (id) {
          return Number(id);
        })
        .filter(function (id) {
          return !!id;
        });
    }

    function getGiftVariantId(gift) {
      return Number(gift && (gift.variantId || gift.variant_id || gift.id || 0));
    }

    function normalizeRule(rule) {
      if (!rule || !Array.isArray(rule.triggerIds) || !Array.isArray(rule.gifts)) return null;

      var triggerIds = normalizeIds(rule.triggerIds);
      var gifts = rule.gifts.filter(function (gift) {
        return !!getGiftVariantId(gift);
      });

      if (!triggerIds.length || !gifts.length) return null;

      return {
        triggerIds: triggerIds,
        gifts: gifts
      };
    }

    function rulesShareTrigger(ruleA, ruleB) {
      var idsA = normalizeIds(ruleA && ruleA.triggerIds);
      var idsB = normalizeIds(ruleB && ruleB.triggerIds);

      return idsB.some(function (id) {
        return idsA.indexOf(id) !== -1;
      });
    }

    function rememberRule(rule) {
      rule = normalizeRule(rule);
      if (!rule) return null;

      window.CWGiftRules = Array.isArray(window.CWGiftRules) ? window.CWGiftRules : [];

      window.CWGiftRules = window.CWGiftRules.filter(function (existingRule) {
        return !rulesShareTrigger(existingRule, rule);
      });

      window.CWGiftRules.push(rule);
      window._pendingGiftRule = rule;

      var cartConfig = getCartConfig();
      cartConfig.giftRules = Array.isArray(cartConfig.giftRules) ? cartConfig.giftRules : [];
      cartConfig.giftRules = cartConfig.giftRules.filter(function (existingRule) {
        return !rulesShareTrigger(existingRule, rule);
      });
      cartConfig.giftRules.push(rule);
      setCartConfig(cartConfig);

      if (window.GiftSync && typeof window.GiftSync.registerRule === 'function') {
        window.GiftSync.registerRule(rule);
      }

      return rule;
    }

    function getSelectedVariantIdFromForm(form) {
      if (!form) return 0;

      if (window.__ks_variantId) {
        return Number(window.__ks_variantId);
      }

      var activeSwatch = document.querySelector('.cw-colors-swatchers__item.is-active[data-variant-id]');
      if (activeSwatch && activeSwatch.getAttribute('data-variant-id')) {
        return Number(activeSwatch.getAttribute('data-variant-id'));
      }

      var formData = new FormData(form);
      var formVariantId = formData.get('id');

      if (formVariantId) {
        return Number(formVariantId);
      }

      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) {
        return Number(idInput.value);
      }

      var selectedVariantEl = form.querySelector(
        '[data-variant-id].is-selected, [data-variant-id][aria-checked="true"], [data-variant-id][aria-selected="true"]'
      );

      if (selectedVariantEl && selectedVariantEl.getAttribute('data-variant-id')) {
        return Number(selectedVariantEl.getAttribute('data-variant-id'));
      }

      return 0;
    }

    function syncFormVariantId(form, variantId) {
      if (!form || !variantId) return;

      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;

      idInput.value = String(variantId);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function getProductIdFromForm(form, config) {
      return Number(
        form && (
          form.getAttribute('data-productid') ||
          form.getAttribute('data-product-id') ||
          form.querySelector('[name="product-id"]')?.value ||
          form.querySelector('[name="product_id"]')?.value
        )
      ) || Number(config && config.product && config.product.id) || 0;
    }

    function getQuantityFromForm(form) {
      if (!form) return 1;

      var formData = new FormData(form);
      return Math.max(1, Number(formData.get('quantity') || form.querySelector('[name="quantity"]')?.value || 1));
    }

    function getSellingPlanFromForm(form) {
      if (!form) return '';

      var formData = new FormData(form);
      return String(formData.get('selling_plan') || form.querySelector('[name="selling_plan"]')?.value || '').trim();
    }

    function getLineItemPropertiesFromForm(form) {
      var properties = {};
      if (!form) return properties;

      var formData = new FormData(form);

      formData.forEach(function (value, key) {
        var match = String(key).match(/^properties\[(.+)\]$/);
        if (!match || value === '') return;

        properties[match[1]] = value;
      });

      return properties;
    }

    function getPDPGiftRule(form) {
      var config = getPDPConfig();
      var variantId = getSelectedVariantIdFromForm(form);
      var variantRules = config.variantGiftRules || {};
      var variantRule = variantRules[String(variantId)];

      return normalizeRule(variantRule) || normalizeRule(config.giftRule);
    }

    function getCardGiftRule(button) {
      var rawRule = button.getAttribute('data-gift-rule');
      return normalizeRule(parseJson(rawRule));
    }

    function getGiftQuantity(mainQuantity) {
      return Math.min(GIFT_MAX_QTY, Math.max(1, Number(mainQuantity || 1)));
    }

    function buildPayload(main) {
      var rule = rememberRule(main.rule);
      var mainQuantity = Math.max(1, Number(main.quantity || 1));
      var giftQuantity = getGiftQuantity(mainQuantity);

      var mainItem = {
        id: Number(main.variantId),
        quantity: mainQuantity
      };

      if (main.sellingPlanId) {
        mainItem.selling_plan = main.sellingPlanId;
      }

      if (main.properties && Object.keys(main.properties).length) {
        mainItem.properties = main.properties;
      }

      var items = [mainItem];

      if (rule && rule.gifts && rule.gifts.length) {
        rule.gifts.forEach(function (gift) {
          var giftVariantId = getGiftVariantId(gift);

          if (!giftVariantId || giftVariantId === Number(main.variantId)) return;

          items.push({
            id: giftVariantId,
            quantity: giftQuantity,
            properties: {
              _gift: 'true',
              _parent_product_id: String(main.productId || ''),
              _parent_variant_id: String(main.variantId || '')
            }
          });
        });
      }

      return {
        items: items
      };
    }

    async function addToCart(payload) {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        var error;

        try {
          error = await response.json();
        } catch (_) {
          error = {};
        }

        throw error;
      }

      return response.json();
    }

    async function fetchCart() {
      var response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      return response.json();
    }

    function notifyCartUpdated(cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart: cart
        }
      }));

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cart
        }
      }));

      window.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: {
          cart: cart
        }
      }));
    }

    function openCartDrawer(cart) {
      notifyCartUpdated(cart);

      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        Promise.resolve(window.CartDrawer.refresh(cart)).then(function () {
          if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
            window.CartDrawer.open();
          }
        });

        return;
      }

      if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
        window.theme.cartDrawer.open();
      }
    }

    function setButtonLoading(button, isLoading) {
      if (!button) return;

      var textEl = button.querySelector('[data-add-to-cart-text]');
      var defaultText = textEl ? textEl.getAttribute('data-default-text') || textEl.textContent : button.textContent;

      if (!button.dataset.defaultText) {
        button.dataset.defaultText = defaultText;
      }

      button.disabled = !!isLoading;

      if (textEl) {
        textEl.textContent = isLoading ? 'Adding...' : button.dataset.defaultText;
      } else {
        button.textContent = isLoading ? 'Adding...' : button.dataset.defaultText;
      }
    }

    async function handleProductFormSubmit(event) {
      var form = event.target;

      if (!form || !form.classList || !form.classList.contains('product-single__form')) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var button = form.querySelector('[data-add-to-cart]');
      var config = getPDPConfig();
      var variantId = getSelectedVariantIdFromForm(form);
      var productId = getProductIdFromForm(form, config);
      var quantity = getQuantityFromForm(form);
      var sellingPlanId = getSellingPlanFromForm(form);
      var properties = getLineItemPropertiesFromForm(form);
      var rule = getPDPGiftRule(form);

      if (!variantId) {
        (window.ksToast || window.alert)('Missing selected variant ID.');
        return;
      }

      syncFormVariantId(form, variantId);
      setButtonLoading(button, true);

      try {
        var payload = buildPayload({
          variantId: variantId,
          productId: productId,
          quantity: quantity,
          sellingPlanId: sellingPlanId,
          properties: properties,
          rule: rule
        });

        await addToCart(payload);

        var cart = await fetchCart();
        openCartDrawer(cart);
      } catch (error) {
        console.error('[MetafieldGiftATC] PDP add failed:', error);
        (window.ksToast || window.alert)(error && (error.description || error.message) ? (error.description || error.message) : 'Could not add item to cart.');
      } finally {
        setButtonLoading(button, false);
      }
    }

    async function handleCardButtonClick(event) {
      var button = event.target.closest('.cw-hp-product-atc-btn');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var variantId = Number(button.getAttribute('data-variant-id') || 0);
      var productId = Number(button.getAttribute('data-product-id') || 0);
      var sellingPlanId = String(button.getAttribute('data-selling-plan-id') || '').trim();
      var rule = getCardGiftRule(button);

      if (!variantId) {
        (window.ksToast || window.alert)('Missing selected variant ID.');
        return;
      }

      setButtonLoading(button, true);

      try {
        var payload = buildPayload({
          variantId: variantId,
          productId: productId,
          quantity: 1,
          sellingPlanId: sellingPlanId,
          properties: {},
          rule: rule
        });

        await addToCart(payload);

        var cart = await fetchCart();
        openCartDrawer(cart);
      } catch (error) {
        console.error('[MetafieldGiftATC] Card add failed:', error);
        (window.ksToast || window.alert)(error && (error.description || error.message) ? (error.description || error.message) : 'Could not add item to cart.');
      } finally {
        setButtonLoading(button, false);
      }
    }

    document.addEventListener('submit', handleProductFormSubmit, true);
    document.addEventListener('click', handleCardButtonClick, true);
  })();
}